/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BarChart16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M3.5 10a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 01-1-1v-3a1 1 0 011-1h1zm5-3a1 1 0 011 1v6a1 1 0 01-1 1h-1a1 1 0 01-1-1V8a1 1 0 011-1h1zm5-5a1 1 0 011 1v11a1 1 0 01-1 1h-1a1 1 0 01-1-1V3a1 1 0 011-1h1z"
        />
    </AccessibleSVG>
);

export default BarChart16;
